import React from 'react'
import {Space, Typography, Divider, Card,Tag,} from 'antd'
import {Trans} from "react-i18next";

import {Cell} from '@q4us-sw/q4us-ui/lib/Cell'
import {SectionTitle} from "./Header";


export const Section = ({
                            fetchConfig,
                            data,
                            title,
                            onChange= (values)=>{},
                            schema="default",
                            resolve= (props)=>"",
                            isEditable = (cfg, values)=>false
})=>{
    const [configs, setConfigs] = React.useState([])
    const [values, setValues] = React.useState()

    const load = async ()=>{
        const cfg = await fetchConfig({schema});
        if(typeof data === 'function'){
            const res = await (data);
            setValues(res)
        }else{
            setValues(data)
        }
        setConfigs(cfg)
    }
    React.useEffect(()=>{
        load();
    },[])

    const items = configs.map(o=>{
        if(o.type === 'INLINE_SCHEMA')
            console.log(o)
        return <tr className={"section-item"}>
            <td style={{textAlign: 'right', paddingRight: 20}}>
                <Typography.Text>
                    {o.title} :
                </Typography.Text>
            </td>
            <td style={{textAlign: 'left',paddingLeft: 20}} >
                <Cell
                    schema={schema}
                    type={o.type}
                    name={o.name}
                    title={o.title}
                    value={values[o.name]}
                    onChange={(e) => {
                        onChange({...values, [o.name]: e});
                        setValues({...values, [o.name]: e})
                    }}
                    enums={o.enums}
                    edit={isEditable(o, values)}
                    formatter={(name, type, formatted, value) => {
                        if (isEditable(o, values)) {
                            return value;
                        } else
                            return resolve({...o, value})
                    }}
                />
            </td>
        </tr>
    })

    return <React.Fragment>
        {title && <SectionTitle name={title}/>}
        {
            items
        }
    </React.Fragment>
};
